export const MAX_WIDGET_ITEMS = 20;
export const MILLISECONDS_IN_DAY = 86400000;
